/* eslint-disable */
import { rotaryDetailsFragment } from "@saleor/fragments/rotary";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { RotaryApply, RotaryApplyVariables } from "./types/RotaryApply";
import {
  RotaryBulkDelete,
  RotaryBulkDeleteVariables
} from "./types/RotaryBulkDelete";
import { RotaryCreate, RotaryCreateVariables } from "./types/RotaryCreate";
import { RotaryDelete, RotaryDeleteVariables } from "./types/RotaryDelete";
import {
  RotaryItemsCreate,
  RotaryItemsCreateVariables
} from "./types/RotaryItemsCreate";
import {
  RotaryItemsDelete,
  RotaryItemsDeleteVariables
} from "./types/RotaryItemsDelete";
import {
  RotaryItemsUpdate,
  RotaryItemsUpdateVariables
} from "./types/RotaryItemsUpdate";

import {
  RotaryCopyCreate,
  RotaryCopyCreateVariables
} from "./types/RotaryCopyCreate";
import {
  RotaryUpdateLanguageCode,
  RotaryUpdateLanguageCodeVariables
} from "./types/RotaryUpdateLanguageCode";

import { RotaryUpdate, RotaryUpdateVariables } from "./types/RotaryUpdate";

const rotaryBulkDelete = gql`
  mutation RotaryBulkDelete($ids: [ID!]!) {
    rotaryBulkDelete(ids: $ids) {
      errors: errors {
        message
      }
    }
  }
`;

export const useRotaryBulkDeleteMutation = makeMutation<
  RotaryBulkDelete,
  RotaryBulkDeleteVariables
>(rotaryBulkDelete);

const rotaryCreate = gql`
  mutation RotaryCreate($input: RotaryInput!) {
    rotaryCreate(input: $input) {
      rotary {
        id
      }
      errors: rotaryErrors {
        field
        code
      }
    }
  }
`;

export const useRotaryCreateMutation = makeMutation<
  RotaryCreate,
  RotaryCreateVariables
>(rotaryCreate);

const rotaryDelete = gql`
  mutation RotaryDelete($id: ID!) {
    rotaryDelete(id: $id) {
      errors {
        message
      }
    }
  }
`;

export const useRotaryDeleteMutation = makeMutation<
  RotaryDelete,
  RotaryDeleteVariables
>(rotaryDelete);

const rotaryItemsDelete = gql`
  ${rotaryDetailsFragment}
  mutation RotaryItemsDelete($id: ID!) {
    rotaryItemsDelete(id: $id) {
      rotary {
        ...RotaryDetailsFragment
      }
      errors {
        message
      }
    }
  }
`;

export const useRotaryItemsDeleteMutation = makeMutation<
  RotaryItemsDelete,
  RotaryItemsDeleteVariables
>(rotaryItemsDelete);

const rotaryUpdate = gql`
  mutation RotaryUpdate($id: ID!, $input: RotaryInput!) {
    rotaryUpdate(id: $id, input: $input) {
      errors: rotaryErrors {
        field
        code
      }
    }
  }
`;

export const useRotaryUpdateMutation = makeMutation<
  RotaryUpdate,
  RotaryUpdateVariables
>(rotaryUpdate);

const rotaryApply = gql`
  mutation RotaryApply($id: ID!) {
    rotaryApply(id: $id) {
      errors {
        message
      }
    }
  }
`;

export const useRotaryApplyMutation = makeMutation<
  RotaryApply,
  RotaryApplyVariables
>(rotaryApply);

const rotaryItemsUpdate = gql`
  ${rotaryDetailsFragment}
  mutation RotaryItemsUpdate($id: ID!, $input: RotaryItemsInput!) {
    rotaryItemsUpdate(id: $id, input: $input) {
      rotary {
        ...RotaryDetailsFragment
      }
      errors: rotaryErrors {
        field
        code
      }
    }
  }
`;

export const useRotaryItemsUpdateMutation = makeMutation<
  RotaryItemsUpdate,
  RotaryItemsUpdateVariables
>(rotaryItemsUpdate);

const rotaryItemsCreate = gql`
  ${rotaryDetailsFragment}
  mutation RotaryItemsCreate($input: RotaryItemsInput!) {
    rotaryItemsCreate(input: $input) {
      rotary {
        ...RotaryDetailsFragment
      }
      errors: rotaryErrors {
        field
        code
      }
    }
  }
`;

export const useRotaryItemsCreateMutation = makeMutation<
  RotaryItemsCreate,
  RotaryItemsCreateVariables
>(rotaryItemsCreate);

const rotaryCopyCreate = gql`
  ${rotaryDetailsFragment}
  mutation RotaryCopyCreate($id: ID!) {
    rotaryCopyCreate(id: $id) {
      rotary {
        ...RotaryDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useRotaryCopyCreateMutation = makeMutation<
  RotaryCopyCreate,
  RotaryCopyCreateVariables
>(rotaryCopyCreate);

const rotaryUpdateLanguageCode = gql`
  ${rotaryDetailsFragment}
  mutation RotaryUpdateLanguageCode($id: ID!, $languageCode: String!) {
    rotaryUpdateLanguageCode(id: $id, languageCode: $languageCode) {
      rotary {
        ...RotaryDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useRotaryUpdateLanguageCodeMutation = makeMutation<
  RotaryUpdateLanguageCode,
  RotaryUpdateLanguageCodeVariables
>(rotaryUpdateLanguageCode);
